/*
  Video with text overlay
  - Plays/pauses each section's background video as it enters/leaves the
    viewport (saves battery and bandwidth on long pages).
  - Fades the heading/text/buttons in the first time the section scrolls
    into view (a small, self-contained reveal -- see the matching CSS).
  - Respects prefers-reduced-motion by never auto-playing video and by
    showing text immediately instead of fading it in.
  - Defensive: does nothing for a section with no <video> (e.g. the
    mobile "poster image only" option is selected, or no video has
    been uploaded yet).

  Note: this section intentionally does NOT use the theme's shared
  <image-with-text-overlay> custom element/tag. Two sections sharing
  that exact tag confused Shopify's theme editor when one of them was
  hidden or deleted -- it could wipe out the other section's content.
  This script and its CSS are fully self-contained for this section
  only, with no shared tag and no shared script.
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(section) {
    if (reduceMotion || section.dataset.videoOverlayRevealInit) return;
    section.dataset.videoOverlayRevealInit = 'true';

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-revealed');
      return;
    }

    var revealObserver = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-revealed');
            obs.unobserve(section);
          }
        });
      },
      { threshold: 0.2 }
    );
    revealObserver.observe(section);
  }

  function initVideoSection(section) {
    initReveal(section);

    var videos = Array.prototype.slice.call(section.querySelectorAll('video'));
    if (!videos.length || section.dataset.videoOverlayInit) return;
    section.dataset.videoOverlayInit = 'true';

    videos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          /* Autoplay blocked; video stays on its poster frame. */
        });
      }
    });

    if (!reduceMotion && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            videos.forEach(function (video) {
              if (entry.isIntersecting) {
                var playPromise = video.play();
                if (playPromise && typeof playPromise.catch === 'function') {
                  playPromise.catch(function () {});
                }
              } else {
                video.pause();
              }
            });
          });
        },
        { threshold: 0.15 }
      );
      observer.observe(section);
    }
  }

  function initAll() {
    document.querySelectorAll('.video-with-text-overlay').forEach(initVideoSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('.video-with-text-overlay')
      : null;
    if (section) initVideoSection(section);
  });
})();
